<template>
    <div>
        <div class="searcher-container-negative d-flex flex-wrap mobile-flex-col">
            <!--<v-text-field @input="searchData($event)" label="Busca nombre de la ruta"
                class="searcher form-control form-search" style="min-width: 250px;" single-line
                hide-details></v-text-field>-->

            <select @change="filtrarPorOrden($event)" name="order-filter" id="order-filter"
                class="form-control py-2 px-4 w-auto border-dark mobile-mt-10">
                <option value="">Ordenar por</option>
                <option value="typeRoute">Tipo de Ruta</option>
                <option value="initRoute">Cursos Inscritos</option>
                <option value="insignias">Insignias</option>
                <option value="empresa">Empresa</option>
                <option value="userInscrito">Usuarios Inscritos</option>
            </select>
            <div>
                <label for="showFilters"><input id="showFilters" class="form-check-input" type="checkbox" v-model="showFilters"> Mostrar Filtros</label>
            </div>
        </div>
        <v-data-table
            :headers="headersTabs"
            :items="desserts"
            item-key="name"
            class="elevation-1 table align-middle text-center table-rutas-superadmin"
            :items-per-page="10"
            loading
            loading-text="Cargando..."
            mobile-breakpoint="0"
            :footer-props="{
                prevIcon: 'fa-solid fa-chevron-left',
                nextIcon: 'fa-solid fa-chevron-right',
                'items-per-page-text': 'Mostrando: ',
                'items-per-page-options': [5, 10, 20, 30, 40, 50],
            }"
        >
            <template v-slot:body.prepend>
                <tr v-show="showFilters">
                    <td colspan="1"></td>
                    <td><input type="text" class="form-control" @input="searchData($event)" v-model="busqueda.ruta" placeholder="Ruta"></td>
                    <td><input type="text" class="form-control" @input="searchData($event)" v-model="busqueda.client" placeholder="Empresa"></td>
                    <td><select class="form-control" @change="searchData($event)" placeholder="Seleccione.." v-model="busqueda.tipo"><option value="">Todos</option><option value="custom">Nueva</option><option value="default">Predeterminada</option></select></td>
                    <td colspan="5"></td>
                </tr>
            </template>

            <template v-slot:item="row">
                <tr class="small">
                    <td>{{ row.item.id }}</td>
                    <td style="width: 150px">
                        <div class="text-start lh-1 py-1">
                            <small>
                                {{ row.item.name }}
                            </small>
                        </div>
                    </td>
                    <td style="min-width: 150px">
                        <div class="small fw-bold">
                            <small>{{ row.item.client }}</small>
                        </div>
                    </td>
                    <td style="min-width: 125px">
                        <div class="small fw-bold">
                            <small
                                >{{
                                    row.item.type_of == 'custom'
                                        ? "Nueva"
                                        : "Predeterminada"
                                }}
                            </small>
                        </div>
                    </td>
                    <td>
                        <div class="fw-bold">
                            <label for=""
                            class="showXRoute"
                            data-bs-toggle="modal"
                            data-bs-target="#showInfoXRouteModal"
                            @click="showInfoXRoute(row.item, 'students')">
                            {{ row.item.students_count.count }}</label>
                        </div>
                    </td>
                    <td>
                        <label for=""
                            class="showXRoute"
                            data-bs-toggle="modal"
                            data-bs-target="#showInfoXRouteModal"
                            @click="showInfoXRoute(row.item, 'courses')">
                            {{ row.item.routes_count.count }}
                        </label>
                    </td>
                    <td>
                        <label for=""
                            class="showXRoute"
                            data-bs-toggle="modal"
                            data-bs-target="#showInfoXRouteModal"
                            @click="showInfoXRoute(row.item, 'badges')">
                            {{ row.item.insignias_count.count }}
                        </label>
                    </td>
                    <td>00</td>
                    <td>
                        <div class="d-flex">
                            <button
                                type="button"
                                class="text-primary me-3"
                                data-bs-toggle="modal"
                                data-bs-target="#addModal"
                                @click="
                                    filterDataStudent(
                                        row.item.id,
                                        row.item.client_id
                                    )
                                "
                                title="Agregar usuario a esta ruta"
                            >
                                <i class="fa-solid fa-user-plus"></i>
                            </button>
                            <!--<a class="text-primary me-3" :href="editarruta + '?uuid=' + row.item.uuid"  title="Edita ruta">
                                 Editar ruta
                                <i class="fa-solid fa-pen-to-square"></i>
                            </a> -->
                            <button
                                class="text-primary"
                                @click="destroy = row.item"
                                data-bs-toggle="modal"
                                data-bs-target="#deleteModal"
                                title="Eliminar esta ruta"
                            >
                                <!-- Eliminar ruta -->
                                <i class="fa-regular fa-trash-can"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </template>
        </v-data-table>

        <!--Modal Show Info x Route-->
        <div class="modal fade"
            id="showInfoXRouteModal"
            tabindex="-1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="infoXRouteModalLabel"
            aria-hidden="true">

            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" :class="'modal-'+infoXRoute.modalType">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title">
                            RUTA: {{ infoXRoute.name }}
                        </h5>
                    </div>
                    <div class="modal-body">
                        <div class="row g-3">
                            <div class="col text-center">
                                <div class="table-responsive mb-2">
                                    <table class="table table-sm text-center align-middle mt-3 small">
                                        <thead class="">
                                            <tr>
                                                <th scope="col">
                                                    <div class="d-block text-center">
                                                        {{ infoXRoute.type == 'courses' ? 'CURSOS' : 'NOMBRE DEL USUARIO' }}
                                                    </div>
                                                </th>
                                                <th v-if="infoXRoute.type != 'courses'" scope="col">
                                                    <div class="d-block text-center">
                                                        {{ infoXRoute.type == 'students' ? 'CORREO ELECTRÓNICO' : 'FECHA DE INSÍGNIA' }}
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="infoXRoute.type == 'courses'" class="fs-4" v-for="( item, index ) of infoXRoute.courses" :key="index">
                                                <td>
                                                    <div class="student-info m-0 small">
                                                        <p class="m-0 small">{{ item.wordpress_course_title }}</p>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="infoXRoute.type == 'students'" class="fs-4" v-for="( item, index ) of infoXRoute.students" :key="index">
                                                <td>
                                                    <div class="student-info m-0 small">
                                                        <p class="m-0 small">{{ item.firstname }} {{ item.lastname }}</p>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="student-info m-0 small">
                                                        <p class="m-0 small">{{ item.email }}</p>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="infoXRoute.type == 'badges'" class="fs-4" v-for="( item, index ) of infoXRoute.badges" :key="index">
                                                <td>
                                                    <div class="student-info m-0 small">
                                                        <p class="m-0 small">{{ item.firstname }} {{ item.lastname }}</p>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="student-info m-0 small">
                                                        <p class="m-0 small">{{ item.created_at }}</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a :href="download+`?route=${infoXRoute.id}`" class="btn btn-utel" v-if="infoXRoute.type == 'students'"> Descargar Usuarios</a>
                        <button type="button" class="btn btn-utel btn-inverted" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
        <!--End Modal Courses x Route-->

        <!-- Añadir estudiantes a la ruta modal -->
        <div
            class="modal fade"
            id="addModal"
            tabindex="-1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="addModalLabel"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title">
                            Añadir Usuarios a la ruta de aprendizaje
                        </h5>
                    </div>
                    <div class="modal-body">
                        <div class="row g-3">
                            <div class="col text-center">
                                <div v-show="chargingModalTable" class="spinner-border text-primary" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <div v-show="!chargingModalTable" class="table-responsive mb-2">
                                    <table
                                        class="table table-sm text-center align-middle mt-3 small"
                                    >
                                        <thead class="">
                                            <tr>
                                                <th scope="col">
                                                    <span
                                                        class="text-primary fw-bold"
                                                    >
                                                        <input v-model="isCheckedSelectAll"
                                                            class="form-check-input"
                                                            @change="selectAll"
                                                            type="checkbox"
                                                        />
                                                        ({{
                                                            this
                                                                .selectedStudents
                                                                .length
                                                        }}/{{
                                                            this
                                                                .dessertsStudents
                                                                ? this
                                                                      .dessertsStudents
                                                                      .length
                                                                : 0
                                                        }})
                                                    </span>
                                                </th>
                                                <th scope="col">
                                                    <div
                                                        class="d-block text-center"
                                                    >
                                                        Nombres
                                                    </div>
                                                </th>
                                                <th scope="col">
                                                    <div
                                                        class="d-block text-center"
                                                    >
                                                        Apellidos
                                                    </div>
                                                </th>
                                                <th scope="col">
                                                    <div
                                                        class="d-block text-center"
                                                    >
                                                        Correo Electronico
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                class="fs-4"
                                                v-for="(
                                                    item, index
                                                ) of dessertsStudents"
                                                :key="index"
                                            >
                                                <td>
                                                    <div class="">
                                                        <div class="form-check">
                                                            <input
                                                                v-model="
                                                                    selectedStudents
                                                                "
                                                                class="form-check-input inputUser"
                                                                @change="
                                                                    disableButton
                                                                "
                                                                type="checkbox"
                                                                :value="item.id"
                                                                :id="
                                                                    'checkStudent' +
                                                                    item.id
                                                                "
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div
                                                        class="student-info m-0 small"
                                                    >
                                                        <p class="m-0 small">
                                                            {{ item.firstname }}
                                                        </p>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div
                                                        class="student-info m-0 small"
                                                    >
                                                        {{ item.lastname }}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div
                                                        class="student-info student-mail m-0 small"
                                                    >
                                                        <a
                                                            class="text-primary"
                                                            >{{ item.email }}</a
                                                        >
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button

                            type="button"
                            class="btn btn-utel btn-inverted"
                            data-bs-dismiss="modal"
                        >
                            Cerrar
                        </button>
                        <button
                            id="saveStudentsModal"
                            type="button"
                            class="btn btn-utel text-light"
                            disabled
                            @click="agregarUsuariosARuta"
                        >
                            Guardar cambios
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Editar ruta modal -->
        <div
            class="modal fade"
            id="updateModal"
            tabindex="-1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="updateModalLabel"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title">
                            Editar la ruta de aprendizaje {{ edit.name }}
                        </h5>
                    </div>
                    <div class="modal-body">
                        <div class="row g-3">
                            <div class="col">
                                <input
                                    type="text"
                                    v-model="edit.name"
                                    class="form-control"
                                    placeholder="Nombre de la ruta de aprendizaje"
                                    aria-label="Nombre de la ruta de aprendizaje"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            id="cancel"
                            type="button"
                            class="btn btn-utel btn-inverted"
                            data-bs-dismiss="modal"
                            @click="edit = []"
                        >
                            Cerrar
                        </button>
                        <button
                            id="update"
                            type="button"
                            @click="editarCliente"
                            class="btn btn-utel text-light"
                        >
                            Guardar cambios
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Eliminar ruta modal -->
        <div
            class="modal fade"
            id="deleteModal"
            tabindex="-1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="deleteModalLabel"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title">
                            Eliminar la ruta de aprendizaje {{ destroy.name }}
                        </h5>
                    </div>
                    <div class="modal-body text-center">
                        <span id="response"
                            >¿Esta seguro de eliminiar la ruta de aprendizaje
                            {{ destroy.name }}?</span
                        >
                    </div>
                    <div class="modal-footer">
                        <button
                            id="close"
                            type="button"
                            class="btn btn-utel btn-inverted"
                            data-bs-dismiss="modal"
                            @click="destroy = []"
                        >
                            Cerrar
                        </button>
                        <button
                            id="delete"
                            type="button"
                            @click="eliminarCliente"
                            class="btn btn-utel text-light"
                        >
                            Eliminar la ruta de aprendizaje
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Confirmación -->
        <button
            id="succesBtn"
            type="button"
            class="btn btn-primary invisible"
            data-bs-toggle="modal"
            data-bs-target="#succesModal"
        ></button>
        <div
            class="modal fade"
            id="succesModal"
            tabindex="-1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="succesModalLabel"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title" id="succesModalLabel">
                            {{ successTitle }}
                        </h5>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div class="modal-body text-center">
                        Se ha {{ successMessage }}<br />la ruta correctamente.
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary text-light"
                            data-bs-dismiss="modal"
                        >
                            Aceptar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["get", "headertab", "wptoken", "utlstudents", "userurl", "editarruta","download"],
    data() {
        return {
            searchStudent: "",
            headersTabs: this.headertab,
            url: this.get,
            desserts: [],
            edit: [],
            selectedStudents: [],
            routeSelected: [],
            destroy: [],
            newClient: { name: "" },
            token: this.wptoken,
            successTitle: "",
            successMessage: "",
            dessertsStudents: [],
            infoXRoute: {name:"", courses:[], students: [], badges: [], type: "", modalType : "md"},
            showFilters: false,
            busqueda: { ruta : "", client : "", tipo : "" },
            isCheckedSelectAll: false,
            chargingModalTable: false
        };
    },
    mounted() {
        this.getData();
        this.getStatistics();
    },
    methods: {
        filterDataStudent(idRoute, idClient) {            
            this.chargingModalTable = true;
            this.isCheckedSelectAll = false;
            this.selectedStudents = [];
            document.getElementById("saveStudentsModal").disabled = true;

            let url = this.utlstudents + "?withUsers=true&onlyClient=" + true;
            if (this.empresaSelected) {
                url = this.empresaSelected.users + "?onlyByClient=true";
            }
            if (this.StudentName) {
                url = url + "&search=" + this.StudentName;
            }
            //clearTimeout(this.timeout);
            this.routeSelected.idRoute = idRoute;
            //this.timeout = setTimeout(() => {
                axios
                    .get(
                        `${url}&idClientSelect=${idClient}&routeSelect=${idRoute}`
                    )
                    .then((res) => {
                        this.dessertsStudents = res.data;
                        Vue.nextTick(() => {
                            const usersXRoutes = res.data[0].usersXRoutes;
                            for (let i = 0; i < usersXRoutes.length; i++) {
                                if(document.getElementById(`checkStudent${usersXRoutes[i]}`) != null){
                                    document.getElementById(`checkStudent${usersXRoutes[i]}`).setAttribute('disabled', true);
                                    this.selectedStudents.push(usersXRoutes[i]);
                                }
                            }
                            this.chargingModalTable = false;
                        });                        
                    });
            //}, 300);
        },
        showInfoXRoute(route, type){
            this.infoXRoute.type = type;
            this.infoXRoute.name = route.name;
            this.infoXRoute.id = route.id;
            this.infoXRoute.modalType = type == 'courses' ? 'md' : 'lg';
            this.infoXRoute.badges = type == "badges" ? route.badges_x_route : [];
            this.infoXRoute.courses = type == "courses" ? route.courses_x_route : [];
            this.infoXRoute.students = type == "students" ? route.students_x_route : [];
        },
        getData() {
            axios
                .get(this.url + "?withUsers=true&fullTable=true")
                .then((res) => {
                    this.desserts = res.data;
                });
        },
        getStatistics() {
            //  alert(this.clientUuid);
            // alert('/dashboard/clients/'+this.desserts.client_id+'/report');
            // axios.get('/dashboard/clients/1/report').then((res) => {
            //     this.statistics = res;
            //     console.log("statitics : ",this.statistics);
            // });
        },
        editarCliente() {
            let btn = document.getElementById("update");
            let cancel = document.getElementById("cancel");
            let modal = document.getElementById("updateModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            let succesBtn = document.getElementById("succesBtn");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .put(this.url + "/" + this.edit.uuid, this.edit)
                .then((res) => {
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        this.successTitle = "Edición";
                        this.successMessage = "editado";
                        succesBtn.click();
                    }, 500);
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        eliminarCliente() {
            const response = document.getElementById("response");
            let btn = document.getElementById("delete");
            let cancel = document.getElementById("close");
            let modal = document.getElementById("deleteModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            let succesBtn = document.getElementById("succesBtn");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .delete(this.url + "/" + this.destroy.uuid)
                .then((res) => {
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        btn.textContent = "Eliminar";
                        this.successTitle = "Eliminar";
                        this.successMessage = "eliminado";
                        succesBtn.click();
                    }, 500);
                })
                .catch((err) => {
                    console.log(err.error);
                    response.outerText = "Error al eliminar datos";
                    cancel.removeAttribute("disabled");
                    btn.setAttribute("style", "display:none");

                    setTimeout(() => {
                        btn.removeAttribute("disabled");
                        btn.removeAttribute("style");
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        window.location.reload();
                    }, 1000);
                });
        },
        searchData(event) {
            let search = ``;//`&search=${event}`;
            let searchByName = this.busqueda.ruta != "" ? `&ruta=${this.busqueda.ruta}` : ``;
            let searchByTipo = this.busqueda.tipo != "" ? `&tipo=${this.busqueda.tipo}` : ``;
            let searchByEmpresa = this.busqueda.client != "" ? `&empresa=${this.busqueda.client}` : ``;
            let filters = searchByName+searchByTipo+searchByEmpresa;
            axios
                .get(
                    `${this.url}?withUsers=true&fullTable=true${search}${filters}`
                )
                .then((res) => {
                    this.desserts = res.data;
                });
        },
        filtrarPorOrden(val) {
            const value = val.target.value;
            const arial = document.querySelectorAll("th[aria-label]");
            let busqueda = "";

            switch (value) {
                case "typeRoute":
                    busqueda = "Tipo de la Ruta";
                    break;
                case "initRoute":
                    busqueda = "Cursos iniciadas";
                    break;
                case "insignias":
                    busqueda = "Insignias obtenidas";
                    break;
                case "empresa":
                    busqueda = "Empresas";
                    break;
                case "userInscrito":
                    busqueda = "Usuarios inscritos";
                    break;
            }

            for (let i = 0; i < arial.length; i++) {
                if (arial[i].getAttribute("aria-label").includes(busqueda)) {
                    arial[i].click();
                }
            }
        },
        agregarUsuariosARuta() {
            let btn = document.getElementById("saveStudentsModal");
            let cancel = document.getElementById("cancel");
            let students = [];
            let modal = document.getElementById("addModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            this.selectedStudents.forEach((e) => {
                students.push(e);
            });
            var data = new FormData();
            data.append("students", students);
            data.append("idRoute", this.routeSelected.idRoute);

            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .post(this.userurl, data)
                .then((res) => {
                    if (res.status === 200) {
                        btn.textContent = res.data.message;

                        setTimeout(() => {
                            this.selectedStudents = [];
                            this.getData();
                            btn.textContent = "Guardar cambios";
                            modal.removeAttribute("style");
                            document.body.removeChild(bd[0]);
                            document.body.removeAttribute("class");
                            document.body.removeAttribute("style");
                        }, 800);
                    }
                })
                .catch((err) => {
                    console.log(res);
                });
        },
        disableButton() {
            document.getElementById("saveStudentsModal").removeAttribute("disabled", "disabled");
        },
        selectAll(){
            this.selectedStudents = [];
            let ids = document.getElementsByClassName("inputUser");
            for(let i=0;i<ids.length;i++){
                if((this.isCheckedSelectAll && ids[i].disabled == false) || (ids[i].disabled && ids[i].checked)){
                    this.selectedStudents.push(ids[i].value);
                }
            }
            if(this.isCheckedSelectAll) this.disableButton();
        },
    },
};
</script>
<style>
.showXRoute{
    /*text-decoration: underline;*/
    cursor: pointer;
}
</style>
